import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MarinaMessage } from '../models/marina-message';
import { MarinaMessageVariables } from '../models/marina-message-variables';

@Injectable({
  providedIn: 'root'
})
export class MarinaMessageService {

  private readonly apiUrl = environment.apiHost + '/api-core/secure/marina-message';

  constructor(private http: HttpClient) { }

  listMarinaMessageForType(marinaId: number, type: string): Observable<MarinaMessage | null> {
    const params = new HttpParams().set('type', type);

    return this.http.get<MarinaMessage>(`${this.apiUrl}/listMarinaMessageForType`, {
      params: params,
      headers: { 'Marinaid': marinaId.toString() }
    }).pipe(
      map((response: any) => {
        return response || null;
      })
    );
  }


  save(marinaMessage: MarinaMessage): Observable<MarinaMessage> {
    if (marinaMessage.id) {
      // Usa o endpoint de update para mensagens existentes
      return this.http.put<MarinaMessage>(`${this.apiUrl}/update`, marinaMessage)
        .pipe(map((response: any) => response.data?.marinaMessage || response));
    } else {
      // Usa o endpoint de criação para novas mensagens
      return this.http.post<MarinaMessage>(this.apiUrl, marinaMessage)
        .pipe(map((response: any) => response.data?.marinaMessage || response));
    }
  }


  listVariablesForType(type: string): Observable<MarinaMessageVariables[]> {
    const params = new HttpParams().set('type', type);

    return this.http.get<MarinaMessageVariables[]>(`${this.apiUrl}/listVariablesForType`, {
      params: params
    }).pipe(
      map((response: any) => {
        return response.data?.variables || response || [];
      })
    );
  }
}

